import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import {Router} from '@angular/router';
import {ProductsService} from '../../../shared/services/products.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {ViewVideoComponent} from '../modals/view-video/view-video.component';
import {RecipeListViewModalModel, RecipeViewModel} from '../../../shared/viewModels/recipe.viewModel';

@Component({
    selector: 'app-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideosComponent implements OnInit {
    videos: RecipeViewModel[] = [];
    skip = 0;
    hasMore = false;
    bsModalRef: BsModalRef;

    constructor(
        private readonly productsService: ProductsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly constants: Constants,
        public readonly router: Router,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
    ) {
    }

    ngOnInit() {
        this.loadMore();
    }

    loadMore() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.productsService.getListVideoRecipes(this.skip).subscribe(videos => {
            videos.map(item => {
                this.videos.push(item);
            });

            this.skip += videos.length;
            this.hasMore = videos.length >= 8;

            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        });
    }

    getYoutubeCode(url: string) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : false;
    }

    onViewVideo(recipe: RecipeViewModel) {
        this.bsModalRef = this.bsModalService.show(ViewVideoComponent, {
            backdrop: true
        });

        console.log(recipe);

        this.bsModalRef.content.videoRecipe = recipe;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

}
